import { apiPost } from "../../networkConfig";
import imgUrl from '../../assets/images/profile-dummy-photo.jpg';
import "./ProfileIcons.css";
import { useState, useEffect } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import { getString } from "../../lang";


const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [ getProfilePic, setProfilePic ] = useState(imgUrl);
  const open = Boolean(anchorEl);

  // function to navigate through pages
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  useEffect(() =>{
    let data = JSON.parse(localStorage.getItem("user_info"));

    if(Object.keys(data).length){
      setProfilePic(data.profile_data?.picture || imgUrl);
    }else{
      setProfilePic(imgUrl);
    }
  }, [])

  const handleClose = (event) => {
    if(event.target.innerText === "Logout"){
      logout();
    }
    setAnchorEl(null);
  };

  const clearStorage = () =>{
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("refresh_token");
    window.localStorage.removeItem("user_info");
    navigate("/", { replace: true });
  }

  const logout = async () => {
    let refresh_token = localStorage.getItem("refresh_token");

    try{
      if(refresh_token){
        let res = await apiPost("api/admin_dashboard/admin_logout", { refresh_token: refresh_token });
  
        if(res.data.status){
          toast.success(getString("logged_out_success"));
          clearStorage();
        }else{
          throw new Error("Logout failed ");
        }
      }else{
        toast.success(getString("logged_out_success"));
        clearStorage();
      }
    }catch(err){
      console.log("Error in logout", err);
      toast.success(getString("logged_out_success"));
      clearStorage();
    }
  }

  return (
    <div className='ProfileIcon'>
      <div className='profile-icon-container'>
        <img src={ getProfilePic } alt="profile icon" onClick={ handleClick } />
      </div>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={ handleClose }
      >
        <MenuItem onClick={ handleClose }>{ getString("profile") }</MenuItem>
        <MenuItem onClick={ handleClose }>{ getString("logout") }</MenuItem>
      </Menu>
    </div>
  );
}

export default ProfileMenu;